import React from 'react';
import classNames from 'classnames';
import LinkList from '../ui/link-list/LinkList';
import HeaderLink from '../link/Link';
import PrenavLink from '../prenav-link/PrenavLink';
// eslint-disable-next-line
import SkipLink from '../skip-link/SkipLink';

import styles from './link-list.scss';

const TopLinks = ({
  links,
  isBrandPromiseActive,
  isThresholdActive,
  isNewPreNavActive,
}) => (
  <LinkList
    links={links}
    Item={isNewPreNavActive ? PrenavLink : HeaderLink}
    className={classNames(styles.links, {
      [styles.links__bp]: isBrandPromiseActive,
      [styles.links__threshold]: isThresholdActive,
      [styles.links__prenav]: isNewPreNavActive,
    })}
    isBrandPromiseActive={isBrandPromiseActive}
    isThresholdActive={isThresholdActive}
    isNewPreNavActive={isNewPreNavActive}
  />
);

const SkipLinks = ({ links }) => (
  <LinkList links={links} Item={SkipLink} className={styles.skip} />
);

export { TopLinks, SkipLinks };
